import React, { useEffect } from "react";
import styles from "./scss/videorecordleftsidebar.module.scss";
import CreateDropDown from "../../../chat/leftsidebar/createdropdown";
import { URInput } from "../../../../shared/widgets/input";
import RecordvideoLists from "./contactlists";
import { storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import { getVideoRecordingLists } from "../../../../base/meetingService/apiService";
import noResult from "../../../../styles/images/empty_states/empty-nofound.svg"
import { useSelector } from "react-redux";
import NoContent from "../../../../shared/widgets/noContent";

export default function RecordVideosideBars() {
  let {meetingReducer} : any = useSelector((state: any) => state);
  let {  getRecordListInput,recCount,videoRecordingList } = meetingReducer;

  const navigateToMeetingPage =()=>{
    storeWindowState('mainPage')
   }

  const handleScroll =(e : any)=>{
       const bottom = ((e.target.scrollHeight - Math.abs(e.target.scrollTop)) - e.target.clientHeight);
       if (bottom < 2) {
         let data: any = {};
         data.offset = getRecordListInput.offset + 1;
         data.limit = getRecordListInput.limit;
         data.search = getRecordListInput.search;     
         getVideoRecordingLists(data);  
       }       
    }
  
const searchMeeting = (search:any) => {

let data: any = {};
data.offset = 0;
data.limit= 10;
data.search= search;
getVideoRecordingLists(data)
};


const handleSearchRecList = (e:any)=>{

let searchName:any= e.target.value;
if (searchName!== "") {
searchMeeting(searchName);
}

else {
searchMeeting('');
}}
  
  return (
    <>
    <div className={`${styles.scrolllayerleft}`}>
      <>
      <div className={styles.leftsidebar}>
        <div className={styles.top}>
          <CreateDropDown></CreateDropDown>
        </div>
        <div className={styles.middlelayertop}>
          <URInput placeHolder="Search" className="leftbarsearch" onChange={(e:any)=>handleSearchRecList(e)}/>
        </div>
        <div className={`${styles.scrolllayerleft} ${"scrollerhover"}`} onScroll={handleScroll}>
          <div className={styles.rightbartop}>
            <div className={styles.lefts} onClick={navigateToMeetingPage}>
              <h3><span className="icon_searchlft"></span>Recorded Videos</h3>
            </div>
            {/* <div className={styles.rights}>
              <span>{recCount}</span>
            </div> */}
          </div>
          {videoRecordingList.length > 0 ? <div className={styles.middlelayermiddle}>
           <RecordvideoLists></RecordvideoLists>
           </div> :
          <div>
         <NoContent image={noResult} title={''} description={'No Recorded Video found'} />
         </div>}


        </div>
      </div>
      </>
      </div>
    </>
  );
};

